import axios, { AxiosInstance } from "axios";

export function createHeyLightAdapterAxiosClient(): AxiosInstance {
  return axios.create({
    baseURL: import.meta.env.VITE_HEYLIGHT_ADAPTER_BASE_URL,
  });
}
